/**
 * Per-viewer conveniences only (language, recent workspaces). Storage can be blocked or
 * throw in private windows, so every access is guarded and the app works without it.
 */

export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage unavailable: the preference simply is not remembered.
  }
}
